export interface FitFontSizeOptions {
  min: number;
  max: number;
  charWidthRatio: number;
}

export function fitFontSize(
  text: string,
  availableWidth: number,
  options: FitFontSizeOptions
): number {
  const safeWidth = Math.max(availableWidth, 48);
  const fitted = Math.floor(safeWidth / (text.length * options.charWidthRatio));
  return Math.min(options.max, Math.max(options.min, fitted));
}

export function fitLineHeight(fontSize: number, ratio: number): number {
  return Math.round(fontSize * ratio);
}

export const WELCOME_HEADLINE_FIT: FitFontSizeOptions = {
  min: 28,
  max: 42,
  charWidthRatio: 0.52,
};

export const WELCOME_CARD_TITLE_FIT: FitFontSizeOptions = {
  min: 12,
  max: 16,
  charWidthRatio: 0.52,
};

export const WELCOME_BUTTON_LABEL_FIT: FitFontSizeOptions = {
  min: 11,
  max: 14,
  charWidthRatio: 0.44,
};

export const WELCOME_SUBHEADLINE_FIT: FitFontSizeOptions = {
  min: 11,
  max: 13,
  charWidthRatio: 0.42,
};
